import { DDate } from '@amarkets/atlas/esm/lib/d-date';

export const formatDate = (date: Date | string, format: string = 'DD.MM.YYYY') => new DDate(date).format(format);

export const formatMonthYear = (
  month?: string | number,
  year?: string | number,
  format = 'MM/YY',
): string => {
  if (!month || !year) return '';

  const paddedMonth = String(month).padStart(2, '0');
  const fullYear = String(year).length === 2 ? `20${year}` : String(year);

  const date = new Date(Number(fullYear), Number(paddedMonth) - 1, 1);
  return new DDate(date).format(format);
};
